 /*=========================================================================================
  File Name: state.js
  Description: Restaurant State
  ----------------------------------------------------------------------------------------
  Item Name: Restaurant State Module
  Author: Tan Tran
==========================================================================================*/

export default {
  restaurant : {
    restaurantId : '',
    restaurantName : '',
    restaurantType : '',
    organizationNumber : '',
    description : '',
    address : '',
    phoneNumber : '',
    city: '',
    postNumber : '',
    imageUrl : ''
  },
  SMSSenders : [
    {"restaurantId" : 1, "smsSender" : "FUJI SUSHI", "duration" : 5},
    {"restaurantId" : 2, "smsSender" : "FUJI SUSHI", "duration" : 5},
    {"restaurantId" : 3, "smsSender" : "FUJI SUSHI", "duration" : 5},
    {"restaurantId" : 4, "smsSender" : "FUJI SUSHI", "duration" : 5},
    {"restaurantId" : 5, "smsSender" : "FUJI SUSHI", "duration" : 5},
    {"restaurantId" : 6, "smsSender" : "LA SANDWICH", "duration" : 5},
  ]

}